import styled from 'styled-components';

export const Text = styled.p`
  font-family: var(--font-roboto);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;
